import axios from "axios";
import { baseUrl } from "./config";

/**
 * The maharaj who owns an item's default recipe -- what Item Master's "Default Recipe" field
 * names. An item can carry a recipe per maharaj; at most one of them is flagged `is_default` on
 * receipe_master, and that flag is the single fact both Item Master and the Recipe List write.
 *
 * The menu screens (Menu Creation, Menu Edit, Meal Master) use this to fill Maharaj Name when a
 * menu item is picked: the item says whose recipe stands for it, so the maharaj is not something
 * to remember and re-pick on every menu.
 *
 * Returns null when the item is set to "Auto" -- no default recipe named -- and also when the
 * lookup fails. Both mean the same thing to the caller: leave Maharaj Name to be filled the way
 * it always has been (from the item's category), rather than blanking a good value over a
 * question this item has no answer to.
 *
 * The id comes back as maharaj_master.id, the same number the Maharaj Name dropdowns carry, so it
 * can be dropped straight into the field a person would otherwise have picked.
 */
export const getDefaultRecipeMaharaj = async (menuItemId) => {
  if (!menuItemId) return null;
  try {
    const response = await axios.get(`${baseUrl}/receipe/item_recipes/${menuItemId}`);
    const recipe = (response.data.data ?? []).find((r) => r.is_default == 1 && r.maharaj_id);
    return recipe ? recipe.maharaj_id : null;
  } catch (error) {
    console.log(error);
    return null;
  }
};
